export default __webpack_public_path__ + "static/screver-ocx-preview-07e244f2f986b90fd75704b0f1d3ae69.jpeg";